import React from "react";
import ShowContainer from "../../../../mui/ShowContainer";
import CusButton from "../../../../mui/custom_button/CusButton";
import useBonusHelper from "../../../../../hooks/other/useBonusHelper";
import "./bonus-btn.scss";
import { ENUM_USER_ACTIVE } from "../../../../../store/enums";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setModalBalance } from "../../../../../store/siteSlice";
import BonusTime from "../bonus_time/BonusTime";

export default function BonusBtn({
  showBtnActive,
  onClick,
  disable,
  className = "",
  activateStatus,
  statusForUser,
  activeTo,
  isTime,
  deposit
}) {
  const { t } = useTranslation();
  const { btnTextByStatus } = useBonusHelper();
  const dispatch = useDispatch();
  const activateBtnText = btnTextByStatus(activateStatus, statusForUser);
  const isActivated = activateStatus === ENUM_USER_ACTIVE.activated;
  const bonusAccrued = statusForUser == ENUM_USER_ACTIVE.accrued;

  return (
    <ShowContainer condition={showBtnActive}>
      <div className="bonus__activated__btn">
        {isActivated ? (
          <>
            <ShowContainer condition={deposit && !bonusAccrued}>
              <CusButton
                color="green3"
                text={"Make a deposit"}
                className={className}
                disable={disable}
                onClick={() => dispatch(setModalBalance(deposit))}
              />
            </ShowContainer>

            <BonusTime activeTo={activeTo} isTime={isTime} />

            <span className="cancel" onClick={onClick}>
              {t(activateBtnText)}
            </span>
          </>
        ) : (
          <>
            <CusButton
              color="green3"
              text={activateBtnText}
              className={className}
              onClick={onClick}
              disable={disable}
            />

            <BonusTime activeTo={activeTo} isTime={isTime} />
          </>
        )}
      </div>
    </ShowContainer>
  );
}
